/**
 * Formats a date for display
 * @param timestamp Firebase timestamp or Date object
 * @returns Formatted date string
 */
export function formatDate(timestamp: any): string {
  if (!timestamp) return 'N/A'
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date)
}

/**
 * Formats a date with time for display
 * @param timestamp Firebase timestamp or Date object
 * @returns Formatted date and time string
 */
export function formatDateTime(timestamp: any): string {
  if (!timestamp) return 'N/A'
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

/**
 * Formats a currency value for display
 * @param value Number to format as currency
 * @returns Formatted currency string
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value)
}

/**
 * Formats a weight value for display
 * @param value Weight in pounds
 * @returns Formatted weight string
 */
export function formatWeight(value: number): string {
  return `${value.toFixed(2)} lbs`
}

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
